import {Component} from '@angular/core';
import {Routes} from '@angular/router';
import {BaMenuService} from '../theme';
import {SU_MENU} from './pages.menu';
import {ADMIN_MENU} from './pages.menu';
@Component({
    selector: 'pages',
    template: `
    <ba-sidebar></ba-sidebar>
    <ba-page-top></ba-page-top>
    <div class="al-main">
      <div class="al-content">
        <ba-content-top></ba-content-top>
        </div>
        <div>
        <router-outlet></router-outlet>
      </div>
    </div>
    <footer class="al-footer clearfix">
      <div class="al-footer-main clearfix">
        <div class="al-copy">&copy; <a href="http://tudip.com/" translate> Tudip Technologies </a>{{currentYear}}</div>
      </div>
    </footer>
    <ba-back-top position="200"></ba-back-top>
    `
})
export class Pages {
    currentYear;
    userRoleId: any;
    constructor(private _menuService: BaMenuService) {
        // + sign converts string to number
        this.userRoleId = +localStorage.getItem('user_role_id');
    }

    ngOnInit() {
        switch (this.userRoleId) {
            case 1 : {
                // Super Admin
                this._menuService.updateMenuByRoutes(<Routes>SU_MENU);
                break;
            }
            case 2 : {
                // Admin
                this._menuService.updateMenuByRoutes(<Routes>ADMIN_MENU);
                break;
            }
        }
        this.currentYear = new Date().getFullYear();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.component.ts